/**
 * Constants for application role names
 * Use these constants instead of hardcoded strings for role comparisons
 */
export const RoleConstants = {
  // System-level roles
  SYS_ADMIN: 'sysAdmin',
  DEV_ADMIN: 'devAdmin',
  DEV_VIEWER: 'devViewer',

  // Organization-level roles
  ORGANIZATION_ADMIN: 'Organization Admin',
  ARCHITECT: 'Architect',
  DEVELOPER: 'Developer',
  CONSULTANT: 'Consultant',
  VIEWER: 'Viewer',
  PROTOTYPE_VIEWER: 'Prototype Viewer',
  DEVELOPMENT_VIEWER: 'Development Viewer'
};
